export const SIGNUP_OUTCOME_EXISTING_ACCOUNT_NOTIFIED = 'existing_account_notified' as const;

export type SignupOutcome = typeof SIGNUP_OUTCOME_EXISTING_ACCOUNT_NOTIFIED;

export function isExistingAccountSignupOutcome(signupOutcome: string | undefined): signupOutcome is SignupOutcome {
  return signupOutcome === SIGNUP_OUTCOME_EXISTING_ACCOUNT_NOTIFIED;
}
